import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { ScheduleService } from './schedule.service';
import { SettingsService } from '../settings/settings.service';
import { CoreService } from '../core.service';
import { ProfileService } from '../profile/profile.service';

import { Game, User } from '../app.models';
import { tzDatePipe } from '../app.pipes';

@Component({
	selector: 'app-schedule',
	imports: [ CommonModule, tzDatePipe ],
	templateUrl: './schedule.component.html',
	styleUrl: './schedule.component.scss'
})
export class ScheduleComponent {

	constructor(
		public core: CoreService,
		public schedule: ScheduleService,
		public settings: SettingsService,
		public profile: ProfileService,
	){
		this.core.component_schedule = this;
	}

	subscriptions = [];
	ngOnInit(){

		this.subscriptions.push(
			this.core.stateshot_synced.subscribe( () => this.adjust_date_elements() )
		);
		this.subscriptions.push(
			this.schedule.on_clock_tick.subscribe( () => this.adjust_time_elements() )
		);

		this.subscriptions.push(
			this.core.events.subscribe( (e) => {
				if( e != 'profile.auth-changed' ) return;
				this.user = this.profile.user;
			})
		);
		this.user = this.profile.user;

		if( this.core.games.length > 0 ){
			this.adjust_date_elements();
			this.adjust_time_elements();
		}

	}
	ngOnDestroy(){
		for( let sub of this.subscriptions ) sub.unsubscribe();
	}

	user: User = null;

	date_before_gids: Set<number> = new Set(); //game_ids...
	same_before_gids: Set<number> = new Set(); //game_ids...
	clock_before_gid: number = null;
	clock_unmergable: boolean = false;

	feeds_starts_before_gid: number = null;
	feeds_ends_after_gid: number = null;

	adjust_time_elements(){
		this.clock_before_gid = null;
		this.clock_unmergable = false;

		for( let g of this.core.games )
			if( g.datetime >= this.schedule.clock_datetime ){
				this.clock_before_gid = g.id;
				this.clock_unmergable = !this.schedule.datetimes_on_same_day( g.datetime, this.schedule.clock_datetime )
				break;
			}

		if( this.clock_before_gid && !this.scroll_init ){
			this.scroll_init = true;
			setTimeout(() => this.scroll_now(), 100);
		}
	}
	adjust_date_elements(){
		let last_day = null;
		let last_datetime = null;
		this.date_before_gids.clear()
		this.same_before_gids.clear()

		for( let g of this.core.games ){
			let day = this.schedule.tz_convert_date( g.datetime );
			let date = `${day.getUTCFullYear()}-${day.getUTCMonth()}-${day.getUTCDate()}`;
			if( last_day != date ){
				last_day = date;
				this.date_before_gids.add(g.id);
			}

			if( last_datetime == g.datetime )
				this.same_before_gids.add(g.id);
			last_datetime = g.datetime;
		}
	}

	//scrolling to the important bits
	scroll_init: boolean = false;
	scroll_auto: boolean = true;
	scroll_auto_reactivation_timeout: any = null;
	scroll_now(){
		let node = document.getElementById('clock_element');
		if( !node ) return;

		node.parentNode['scrollTo']({ 'left':node['offsetLeft'] - node.parentNode['offsetWidth']/3 , 'behavior': 'smooth'});
	}
	scroll_cooloff(){ //Called on scroll event and prediction actions;
		this.scroll_auto = false;

		if( this.scroll_auto_reactivation_timeout )
			clearTimeout( this.scroll_auto_reactivation_timeout );

		this.scroll_auto_reactivation_timeout = setTimeout(()=>{
			this.scroll_auto = true;
			this.scroll_now();
		}, 60000);
	}

	//Score spoiler sticker random rotation
	transform_style = {};
	get_transform_style_for( key ){
		if( !this.transform_style[ key ] ){
			let d = Math.random() * 30 - 15;
			this.transform_style[ key ] = `rotate(${d}deg)`;
		}
		return this.transform_style[ key ];
	}


	//Predicting
	get_prediction_teams( p ){
		if( p > 0 ) return [0, p];
		if( p < 0 ) return [-p, 0];
		return [0, 0];
	}

	predictions: any = {}; //game_id -> Range[-4, 4]
	predict_beating: Set<number> = new Set(); //game_id
	predict_loading: Set<number> = new Set(); //game_id
	predict_toggle( g: Game, idx: number ){
		if( !g.is_predictable ) return;
		this.scroll_cooloff();

		let offset = idx ? 1 : -1;

		let sign = this.predictions[g.id] || 0;

		if( offset * sign < 0 ) //Side change
			sign = offset;
		else if( Math.abs(sign) == 4 ) //Cycle
			sign = 0;
		else
			sign += offset; //Side increase

		this.predictions[g.id] = sign;
	}
	prediction_abs_for( g: Game, idx: number ){
		let points = (this.predictions[g.id] || 0) * (idx ? 1 : -1)
		if( points < 0 ) return 0;
		return points;
	}
	async predict( g: Game ) {
		this.scroll_cooloff();

		let id = g.id;
		let signed_points = this.predictions[id];

		if( !signed_points ){
			this.predict_beating.add( id )
			setTimeout( () => { this.predict_beating.delete( id ) }, 1600 );
			return;
		}

		if( !this.profile.is_authenticated ){
			this.core.events.emit("profile.auth-required");
			return;
		}

		this.predict_loading.add( id );

		let response = await this.core.json_request( "POST", "/api/v1/prediction/lock_in_prediction",
			{ 'game_id': g.id, 'on' : signed_points > 0 ? 'H' : 'A', 'amount' : Math.abs(signed_points), 'token': this.profile.user.token },
		)

		if( response.status_code == 201 )
			await this.profile.authenticate();

		this.predict_loading.delete( id );
	}





}
